import { useSelector, useDispatch } from 'react-redux';
import { hideShippingModal } from '../../reducers/shippingModal';
import Modal from '../modal';

const ShippingModal = () => {
  const dispatch = useDispatch();
  const shippingModalReducer = useSelector((state) => state.shippingModal);

  if(shippingModalReducer.show){
    const handleCloseClick = () => {
      dispatch(hideShippingModal());
    }

    return (
      <Modal onCloseClick={handleCloseClick}>
        <h3>Entenda o seu prazo de entrega</h3>

        <p>
          O prazo de entrega mostrado é a quantidade de dias úteis contados a partir da coleta feita pela transportadora ou Correios.
        </p>

        <p>
          Os pedidos realizados até às 8h, serão coletados no mesmo dia.
        </p>

        <p>
          Pedidos realizados após este horário serão enviados no próximo dia útil após a compra.
        </p>
      </Modal>
    )
  }
  else return null;
}

export default ShippingModal;
